import "./Navbar.css";
import { BiHome } from "@react-icons/all-files/bi/BiHome";
import { BiUser } from "@react-icons/all-files/bi/BiUser";
import { AiOutlineInsertRowRight } from "@react-icons/all-files/ai/AiOutlineInsertRowRight";
import { BiBriefcase } from "@react-icons/all-files/bi/BiBriefcase";
import { BiEnvelope } from "react-icons/bi";
import { SiDocsdotrs } from "react-icons/si";
import { Link } from "react-scroll";

const Navbar = () => {
  return (
    <div className="navbar-main-div"
     data-aos="fade-left"
          data-aos-offset="50"
           data-aos-delay="1000"
           data-aos-duration="1000"
     data-aos-easing="ease-in-out "
    >
      <div className="navbar-inner-content">
        <Link
          activeClass="menu-active"
          className="navbar-menu-icons"
          to="home"
          spy={true}
          smooth={true}
          offset={0}
          duration={1000}
        >
          <BiHome />
        </Link>
        <Link
          activeClass="menu-active"
          className="navbar-menu-icons"
          to="about"
          spy={true}
          smooth={true}
          offset={0}
          duration={900}
        >
          <BiUser />
        </Link>
        <Link
          activeClass="menu-active"
          className="navbar-menu-icons"
          to="resume"
          spy={true}
          smooth={true}
          offset={0}
          duration={900}
        >
          <BiBriefcase />
        </Link>
        <Link
          activeClass="menu-active"
          className="navbar-menu-icons"
          to="skill"
          spy={true}
          smooth={true}
          offset={0}
          duration={900}
        >
          <SiDocsdotrs />
        </Link>
        <Link
          activeClass="menu-active"
          className="navbar-menu-icons"
          to="projects"
          spy={true}
          smooth={true}
          offset={0}
          duration={900}
        >
          <AiOutlineInsertRowRight />
        </Link>
        <Link
          activeClass="menu-active"
          className="navbar-menu-icons"
          to="contact"
          spy={true}
          smooth={true}
          offset={0}
          duration={900}
        >
          <BiEnvelope />
        </Link>
      </div>
    </div>
  );
};
export default Navbar;
